const INITIAL_STATE = {
  statusCode: '',
  validationErrors: {},
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'API_REJECTED':
      return {
        statusCode: payload.code,
        validationErrors: {},
      };
    case 'API_VALIDATION_REJECTED':
      return {
        statusCode: payload.code,
        validationErrors: payload.validationErrors || {},
      };
    case 'CLEAR_VALIDATION_ERRORS':
      return {
        ...state,
        validationErrors: {},
      };
    case 'INITIAL_STATE':
    case 'SIGNATURE_INITIAL_STATE':
      return {
        statusCode: payload.statusCode,
        validationErrors: {},
      };
    default:
  }
  return state;
};
